
<li
  class="c-category-menu__item"
  :class="{
    'is-selected': isSelected,
    'has-children': hasChildren
  }"
>
  <a
    class="c-category-menu__link"
    :href="path"
    :data-testid="`button-bar-category-${slug}`"
    @click="onClick"
  >
    {{ name }}

    <vIcon
      v-if="hasChildren"
      name="arrow-right"
      color="primary"
      size="medium"
    />
  </a>
</li>
